<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<template>
  <!-- <div> -->
  <!-- <wx-open-launch-weapp style="display: inline-block;border: none" id="launch-btn" username="gh_b25b65f12de0" path="/pages/index/index">
    <div v-is="'script'" type="text/wxtag-template">
    <button class="btn">打开</button>
  </div>
  </wx-open-launch-weapp> -->
<!-- </div> -->
  <div>
    <img src="img/wx.png" class="wximg" />
    <div class="gotext" @click="goApp()">点击跳转</div>
  </div>
</template>
<!-- <template>
  <div class="index">
    <div class="page">
      <div class="header">
        <img src="img/index/img_bg.png" />
      </div>
      <div class="nav-bar">
        <div class="nav-bar-item" @click="pageJumpCate('/curriculumSchedule?from=yixue')">
          <img src="img/index/img_01.png" />
          <div>已学</div>
        </div>
      </div>
    </div>
  </div>
</template> -->
<script>
import wx from 'weixin-js-sdk'
export default {
  name: 'zxy',
  data () {
    return {
      requestHeadUrl: 'https://douyin.kequbang.com',
      // requestHeadUrl: 'http://localhost:8180',
      isOpenVipModular: false,
      showModal: false, // 是否展示弹窗
      isVip: 0,
      storeId: '',
      userId: '',
      isMiniProgram: true,
      appLink: ''
    }
  },
  created () {
    const thisObj = this
    thisObj.onLoad()
  },
  methods: {
    onLoad: function () {
      // const payParam = {
      //       appId: 'wxa55c200673db6dc7',
      //       package: 'result.resultData.package',
      //       paySign: 'result.resultData.sign',
      //       signType: 'MD5',
      //       timeStamp: 'result.resultData.timeStamp',
      //       nonceStr: 'result.resultData.nonceStr'
      //     }
      // this.navigateToMiniProgram(JSON.stringify(payParam))
      var rr = window.location.href.split('/')
      console.log(rr[rr.length-1])
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/dyLink/dy/openlink?fromDevice=h5&linkId='+rr[rr.length-1], {}).then(res => {
        // console.log(res)
        if (res.resultCode === 200 && res.success) {
          thisObj.appLink = res.resultData.openlink 
          location.href=res.resultData.openlink;  
        } else {
          thisObj.$util.requetServerError(res.resultMsg)
        }
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
      // thisObj.$api.get(thisObj.requestUrl + '/auth/knowledge/dy/app/openlink?fromDevice=h5&knowledgeOpenPersonId=1', {}).then(res => {
      //   // console.log(res)
      //   if (res.resultCode === 200 && res.success) {
      //     console.log(res) 
      //   } else {
      //     thisObj.$util.requetServerError(res.resultMsg)
      //   }
      // }).catch(function (error) {
      //   thisObj.$util.requetServerError(error)
      // })
      // thisObj.$api.get(thisObj.requestUrl + '/auth/knowledge/dy?fromDevice=h5&knowledgeOpenPersonId=1', {}).then(res => {
      //   // console.log(res)
      //   if (res.resultCode === 200 && res.success) {
      // // location.href=res.resultData.openlink;
      //     wx.config({
      //       debug: true, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印
      //       appId: 'wxa55c200673db6dc7', // 必填，公众号的唯一标识
      //       timestamp: res.resultData.timestamp, // 必填，生成签名的时间戳
      //       nonceStr: res.resultData.nonceStr, // 必填，生成签名的随机串
      //       signature: res.resultData.signature,// 必填，签名
      //       jsApiList: ['onMenuShareTimeline'], // 必填，需要使用的 JS 接口列表
      //       openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      //     });
      //     wx.ready(function () {
      //       console.log('ok')
      //       // config信息验证后会执行 ready 方法，所有接口调用都必须在 config 接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在 ready 函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在 ready 函数中
      //     });
      //     wx.error(function (res) {
      //       alert(res)
      //       // config信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的debug模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名
      //       console.log('error')
      //       console.log(res)
      //     });
      //   } else {
      //     thisObj.$util.requetServerError(res.resultMsg)
      //   }
      // }).catch(function (error) {
      //   thisObj.$util.requetServerError(error)
      // })
      // return
    },
    goApp() {
      location.href=this.appLink
    },
    // 页面跳转
    pageJump (uri, item) {
      const thisObj = this
      let queryData = {
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    // 页面跳转
    pageJumpCate (uri) {
      const thisObj = this
      let queryData = {
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    
  }
}
</script>

<style>
.btn {
    padding: 12px;
    width: 200px;
    height: 50px;
}
.wximg {
  position: fixed;
  width: 30%;
  left: 35%;
  top: 30%;
}
.gotext {
  position: fixed;
  bottom: 20%;
  left: 30%;
  width: 40%;
  height: 80px;
  background: rgb(40, 196, 69);
  color: #ffffff;
  text-align: center;
  font-size: 35px;
  padding: 15px;
  border-radius: 15px;
}
</style>
